import React from "react";
import { useState,useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/SortFlagReport.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
//import SalespersonSidebar from "./SalespersonSidebar";
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const columns = [
    {
        field: 'first_name',
        headerName: 'First Name',  
        headerClassName:'first_name_header',    
        flex:1,
        sortable:false,
        // minWidth:79,
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.first_name}
            </Link>
        ),
    },
    {
        field: 'last_name',
        headerName: 'Last Name',    
        headerClassName:'last_name_header',
        flex:1,
        sortable:false,
        // minWidth:79,
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.last_name}
            </Link>
        ),
    },
    {
        field: 'email',
        headerName: 'EMail',
        cellClassName:'email_column',headerClassName:'email_header',   
        flex:1, 
        // minWidth: 125,
        sortable:false,    
    },
    {
        field: 'products_purchased',
        headerName: 'Product Purchased',   
        headerClassName:'product_purchased_header',
        flex:1,
        sortable:false,
        // minWidth:130,
    },
    {
        field: 'amount',
        headerName: 'Amount',   
        headerClassName:'amount_header',
        flex:1,
        sortable:false,
        // minWidth:93,
    },
    {
        field: 'payment_date',
        headerName: 'Payment Date',
        headerClassName:'payment_date_header',   
        flex:1,
        sortable:false,
        // minWidth:100,
    },
    {
        field: 'phone',
        headerName: 'Phone',   
        headerClassName:'phone_header',
        flex:1,
        sortable:false,
        // minWidth:115,
    },
    {
        field: 'country',
        headerName: 'Country',   
        headerClassName:'country_header',
        flex:1,
        sortable:false,
        // minWidth:100,
    },
    {
        field: 'updated_date',
        headerName: 'Updated Date',
        headerClassName:'updated_date_header',   
        flex:1,
        sortable:false,
        // minWidth:115,
    },
    {
        field: 'salesperson',
        headerName: 'Salesperson',
        headerClassName:'salesperson_header',   
        flex:1,
        sortable:false,
        // minWidth:123,
    },

    {
        field: 'full_app',
        headerName: 'Full App',  
        headerClassName:'full_app_header', 
        flex:1,
        sortable:false,
        // minWidth:90,
    },
];

const SortFlagReport = () => {

    // const initialSortFlagForm = {
    //     start_date:'',
    //     start_date_obj: null,
    //     end_date:'',
    //     end_date_obj: null,
    //     pay_start_date:'',
    //     pay_start_date_obj: null,
    //     pay_end_date: '',
    //     pay_end_date_obj: null,
    //     roles: '',
    //     sortflags:[],
    //     salesperson:''
    // };

    const initialSortFlagForm = () => {
        const params = new URLSearchParams(window.location.search);

        const defaultForm = {
            start_date: '',
            start_date_obj: null,
            end_date: '',
            end_date_obj: null,
            pay_start_date: '',
            pay_start_date_obj: null,
            pay_end_date: '',
            pay_end_date_obj: null,
            roles: '',
            sortflags:[],
            salesperson: '',
            action:''
        };

        //  normal dates
        const queryStart = params.get("start_date");
        const queryEnd = params.get("end_date");

        const startObj =
            queryStart
            ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const endObj =
            queryEnd
            ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        //  payment dates
        const queryPaydayStart = params.get("pay_start_date");
        const queryPaydayEnd = params.get("pay_end_date");

        const paydayStartObj =
            queryPaydayStart
            ? new Date(queryPaydayStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const paydayEndObj =
            queryPaydayEnd
            ? new Date(queryPaydayEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        // const sortflags = (() => {
        //     if (!params.has("sortflags")) return [];

        //     const allSortflags = params.getAll("sortflags");

        //     if (allSortflags.length > 1) {
        //         return allSortflags.filter(Boolean); 
        //     }

        //     if (allSortflags.length === 1) {
        //         if (!allSortflags[0]) return []; 

        //         return allSortflags[0]
        //         .split(",")
        //         .filter(Boolean); 
        //     }

        //     return [];
        // })();
        const sortflags = (() => {
        const values = [];

        for (const [key, value] of params.entries()) {
            if (key.startsWith("sortflags[")) {
            if (value) values.push(value);
            }
        }

        return values;
        })();

        return {
            ...defaultForm,
            sortflags: sortflags,
            salesperson: params.get("salesperson") || defaultForm.salesperson,
            roles: params.get("roles") || defaultForm.roles,

            //  normal dates
            start_date: startObj ? queryStart : '',
            start_date_obj: startObj,

            end_date: endObj ? queryEnd : '',
            end_date_obj: endObj,

            //  payment dates
            pay_start_date: paydayStartObj ? queryPaydayStart : '',
            pay_start_date_obj: paydayStartObj,

            pay_end_date: paydayEndObj ? queryPaydayEnd : '',
            pay_end_date_obj: paydayEndObj,

            action:''
        };
        };      

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const paymentStartDateRef = useRef(null);
    const paymentEndDateRef = useRef(null);

    const [isLoading, setIsLoading] = useState(true);

    const [formData, setFormData] = useState(initialSortFlagForm());
    const [appliedFormData, setAppliedFormData] = useState(initialSortFlagForm());
    const[salespersonList, setSalespersonList] = useState({});
    const[sortflagList, setSortflagList] = useState({});
    const[selectedsf, setSelectedsf] = useState('');
    const[rolesList, setRolesList] = useState({});
    const[totalAmount, setTotalAmount] = useState(0);
    const [submittedData, setSubmittedData] = useState(null);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [formErrors, setFormErrors] =useState({}); 
    const [isSubmitted, setIsSubmitted] = useState(false);   

    const app_url = configData.APP_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSortFlagFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, sortflags: selectedValues }));
    };

    // const handleAppStartDateChange = (date) => {
    //   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //   setFormData(prev => ({ ...prev, start_date: formattedDate }));
    // };
    // const handleAppEndDateChange = (date) => {
    //   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //   setFormData(prev => ({ ...prev, end_date: formattedDate }));
    // };
    // const handlePaymentDateChange = (date, name) => {
    //   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //   setFormData(prev => ({ ...prev, [name]: formattedDate }));
    // };

    const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,
        [field]: date ? format(date, 'yyyy-MM-dd') : ''
    }));
    };

    useEffect(() => {
        
       Promise.all([
            getsalespersonlist(),
            retrieveSortFlags(),
            getroleslist()
          ]).then(() => {
     
            setIsLoading(false);
          })
     
    },[]); 
  
    async function getroleslist() {
        try {
            const response = await fetch(
                app_url+'user/getfullroleslist',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setRolesList(responsedata.data.result);
                console.log(rolesList.length);
            } 
        } catch (err) {
            
        }     
    }

    async function  retrieveSortFlags() {
    
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'sortflag/getsortflaglist',
                {
                    method: "GET",
    
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setSortflagList(responsedata.data.result);
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    }

    async function getsalespersonlist() {
        try {
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }    
    }

      React.useEffect(() => {
        if(formData.sortflags.length > 0) {
            const fetchData = async () => {
            // Simulate API call to your server
             // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'sortflag/sortflagreport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
        //   formData:appliedFormData
        formData: {
            ...appliedFormData,
            action: isSubmitted ? 'submit' : ''
        }
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setTotalAmount(data.data.totalpayment);
      setSelectedsf(data.data.selected_sf);
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
            if (isSubmitted) {
                setIsSubmitted(false);
            }
          }
          
    };
    

    fetchData();
  }
      }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 


    const validateDates = (formData) => {
        let errors = {};

        if (!formData.start_date && formData.end_date) {
            errors.start_date = "Start date is required.";
        }

        if (!formData.end_date && formData.start_date) {
            errors.end_date = "End date is required.";
        }

        if (formData.start_date && formData.end_date) {
            const start = new Date(formData.start_date);
            const end = new Date(formData.end_date);
            if (end < start) {
                errors.end_date = "End date cannot be before start date.";
            }
        }

        if (!formData.pay_start_date && formData.pay_end_date) {
            errors.pay_start_date = "Start date is required.";
        }

        if (!formData.pay_end_date && formData.pay_start_date) {
            errors.pay_end_date = "End date is required.";
        }

        if (formData.pay_start_date && formData.pay_end_date) {
            const start = new Date(formData.pay_start_date);
            const end = new Date(formData.pay_end_date);
            if (end < start) {
                errors.pay_end_date = "End date cannot be before start date.";
            }
        }

        return errors;
    };


    const submitFormData = async (data) => {
        setSubmittedData(data);
        setAppliedFormData(data);
        setIsSubmitted(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload

        const errors = validateDates(formData);

        if (Object.keys(errors).length > 0) {
            console.log("Validation errors:", errors);
            setFormErrors(errors); 
            return;
        }
        setFormErrors({});
        setPaginationModel({
            page: 0,
            pageSize: 50,
        });
        setSubmittedData(formData);
        setAppliedFormData({...formData});
        setIsSubmitted(true);
    //  try {
    //     setIsLoading(true);
    //   const response = await fetch(app_url+'sortflag/sortflagreport', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       page: 0,
    //       pageSize: 50,
    //       sortModel,
    //       filterModel,
    //       formData:formData
    //     }),
    //   });
    //   const data = await response.json();
    
    //   setRows(data.data.rows);
    //   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //   setTotalAmount(data.data.totalpayment);
    //   setSelectedsf(data.data.selected_sf);
    //   }  catch (error) {
    //         console.error('Error fetching data:', error);
    //       } finally {
    //         setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //       }
   
    
    };

    const handleExport = async (e) => {
      //  e.preventDefault(); // stop page reload

        const errors = validateDates(formData);

        if (Object.keys(errors).length > 0) {
            console.log("Validation errors:", errors);
            setFormErrors(errors); 
            return;
        }
        setFormErrors({});
   
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'sortflag/sortflagreportexport', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    formData:formData
                }),
            });
            const data = await response.json();
           const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);

    //     if ([...params.keys()].length > 0) {
    //     const init = initialSortFlagForm();

    //     setFormData(init);

    //     submitFormData(init);              
    //     }
    // }, []);
const normalizeBackendData = (backendParams) => {
  return {
    ...backendParams,

    start_date_obj: backendParams.start_date
      ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
      : null,

    end_date_obj: backendParams.end_date
      ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
      : null,

    pay_start_date_obj: backendParams.pay_start_date
      ? new Date(backendParams.pay_start_date.replace(/-/g, "/") + " 00:00:00")
      : null,

    pay_end_date_obj: backendParams.pay_end_date
      ? new Date(backendParams.pay_end_date.replace(/-/g, "/") + " 00:00:00")
      : null,
  };
};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const reportViewId = params.get("report_view_id");

  const baseForm = initialSortFlagForm(); 

  if (reportViewId) {
    const fetchData = async () => {
      try {
        const res = await fetch(app_url + 'report/getreportfilters', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: reportViewId }),
        });

        const data = await res.json();
        const backendParams = data?.data?.params || {};

        //  normalize backend
        const normalized = normalizeBackendData(backendParams);

        //  merge (backend overrides URL/defaults)
        const finalData = {
          ...baseForm,
          ...normalized,
        };

        setFormData(finalData);
        submitFormData(finalData);

      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  } else {
    //  fallback → only URL/default
    if ([...params.keys()].length > 0) {
      setFormData(baseForm);
      submitFormData(baseForm);
    }
  }

}, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="sort-flag-reports-main">
                    <Helmet><title>Sort Flag Report</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="sortflag-report-container">
                            <h1>Sort Flag Report</h1>
                            <div className="messages warning">
                                <p>If you're looking up large amounts of data, please wait for the report to load.</p><br />
                                <p>If your search is not successful (i.e. system crashes), try a shorter date range.</p>
                            </div>
                            <br />
                            <div>
                            <form id="exportForm" onSubmit={handleSubmit}>
                                <div className="sort-flag-report-input-container">
                                    <label>Date of App Start Date:</label>
                                    <DatePicker
                                        ref={startDateRef}
                                        selected={formData.start_date_obj}
                                        id="start_date"
                                        name="start_date" 
                                        onChange={(date) => {
                                            handleDateChange(date, 'start_date');
                                            setTimeout(() => {
                                                const input = startDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        className=""
                                        autoComplete="off"
                                    />
                                    {formErrors.start_date && (
                                        <div className="error">{formErrors.start_date}</div>
                                    )}
                                </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Date of App End Date:</label>
                                    <DatePicker
                                        ref={endDateRef}
                                        selected={formData.end_date_obj}
                                        id="end_date"
                                        name="end_date" 
                                        onChange={(date) => {
                                            handleDateChange(date, 'end_date');
                                            setTimeout(() => {
                                                const input = endDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        className=""
                                        autoComplete="off"
                                    /> 
                                    {formErrors.end_date && (
                                        <div className="error">{formErrors.end_date}</div>
                                    )}
                                </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Payment Start Date:</label> 
                                    <DatePicker
                                        ref={paymentStartDateRef}
                                        selected={formData.pay_start_date_obj}
                                        id="pay_start_date"
                                        name="pay_start_date" 
                                        onChange={(date) => {
                                            handleDateChange(date, 'pay_start_date');
                                            setTimeout(() => {
                                                const input = paymentStartDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        className=""
                                    /> 
                                    {formErrors.pay_start_date && (
                                        <div className="error">{formErrors.pay_start_date}</div>
                                    )}
                                </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Payment End Date:</label> 
                                    <DatePicker
                                        ref={paymentEndDateRef}
                                        selected={formData.pay_end_date_obj}
                                        id="pay_end_date"
                                        name="pay_end_date" 
                                        onChange={(date) => {
                                            handleDateChange(date, 'pay_end_date');
                                            setTimeout(() => {
                                                const input = paymentEndDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        className=""
                                    /> 
                                    {formErrors.pay_end_date && (
                                        <div className="error">{formErrors.pay_end_date}</div>
                                    )}
                                </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Roles:</label> 
                                    <select 
                                        id="roles" 
                                        name="roles" 
                                        style={{border: "1px solid"}}
                                        onChange={handleChange}
                                        value={formData.roles}
                                    > 
                                        <option value="">Select</option>
                                        {rolesList.length > 0 && (
                                            <>
                                                {rolesList.map((item, index) => {
                                                    return <>
                                                        {item['id'] != null && (
                                                            <><option value={item['id']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                    </select>
                                </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Sort Flags:</label> 
                                    <select 
                                        name="sortflags" 
                                        multiple={true}
                                        size="15" 
                                        className="form-select" 
                                        required  
                                        onInvalid={(e) =>
                                            e.target.setCustomValidity("Please select an item in the list")
                                        }
                                        onInput={(e) => e.target.setCustomValidity("")}                                      
                                        onChange={handleSortFlagFocusChange}
                                        value={formData.sortflags || []}
                                    >
                                        {sortflagList.length > 0 && (
                                            <>
                                                {sortflagList.map((item) => {
                                                    return <>
                                                        {item['id'] != null && (
                                                            <><option value={item['id']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                    </select>                                    
                                  
                                 </div>
                                <div className="sort-flag-report-input-container">
                                    <label>Salesperson:</label>
                                    <select 
                                        id="salesperson" 
                                        name="salesperson" 
                                        style={{width:"300px",border:"1px solid #ccc",padding: "2px"}}
                                        onChange={handleChange}
                                        value={formData.salesperson}
                                    >
                                        <option value="ALL">ALL</option>
                                        {salespersonList.length > 0 && (
                                            <>
                                                {salespersonList.map((item) => {
                                                    return <>
                                                        {item['uid'] != null && (
                                                            <><option value={item['uid']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                        <option value="Unassigned">Unassigned</option>
                                    </select>
                                </div>
                                <div className="form-item">
                                    <input type="submit" name="" value="submit" className="form-submit" /> 
                                    {/* <input type="button" name="" value="export" className="form-submit" onClick={handleExport} /> */}
                                    {/* <input type="submit" name="" value="export" className="form-submit"/> */}
                                      <button
                                        type="button"
                                        className="form-submit"
                                        onClick={() => {
                                        const form = document.getElementById("exportForm");
                                        if (form.reportValidity()) {
                                            //  Only runs if form is valid
                                            handleExport();
                                        }
                                        }}
                                    >
                                        Export
                                    </button>
                                </div>
                            </form>
                            </div>
                            <div>
                               {submittedData && (
                                    <div className="flag-report-container">
                                        <div className="">
                                            <h1>Report</h1>
                                            <div>
                                                <b>Sort Flags:</b>
                                                <span>
                                                   {selectedsf}
                                                </span>
                                            </div>
                                            <div id="total_apps" style={{padding:"33px",marginRight:"20px"}}>Total Apps: {rowCount}</div>
                                            <div id="total_apps" style={{marginRight:"2%"}}>Total Amount:{totalAmount} </div>
                                        </div>
                                        <div className="flag-report-content">
                                            <table className="flag-report-table">
                                                <div>
                                                    <DataGrid
                                                        rows={rows}
                                                        columns={columns}
                                                        rowCount={rowCount}
                                                        paginationMode="server"
                                                        sortingMode="server"
                                                        filterMode="server"
                                                        paginationModel={paginationModel}
                                                        onPaginationModelChange={setPaginationModel}
                                                        sortModel={sortModel}
                                                        onSortModelChange={setSortModel}
                                                        filterModel={filterModel}
                                                        onFilterModelChange={setFilterModel}
                                                        pageSizeOptions={[5, 10, 25,50]}
                                                        getRowId={() => crypto.randomUUID()}
                                                        getRowHeight={() => 'auto'}
                                                        disableColumnFilter 
                                                       // disableColumnResize={true}
                                                    />
                                                </div>
                                            </table>
                                        </div>
                                        <div style={{marginTop:"15px"}}>Total:{rowCount}</div>
                                    </div>
                               )}
                               
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        {/* <SalespersonSidebar /> */}
                    </div>
                </div>
            )}
        </>
    );
};
export default SortFlagReport;